import { DIALOG_DATA, DialogRef } from "@angular/cdk/dialog";
import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  TemplateRef,
} from "@angular/core";
import { Icon, IconRegistryService, IconX } from "pax-ui/icons";

import { Button } from "../button";
import { Markdown } from "../markdown";

export interface DialogData {
  title: string;
  contentAsMarkdown?: string;
  contentTemplate?: TemplateRef<unknown>;
  showCloseButton?: boolean;
}

@Component({
  standalone: true,
  selector: "pax-dialog",
  imports: [Markdown, CommonModule, Button, Icon],
  templateUrl: "./dialog.html",
  styleUrls: ["./dialog.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent<T extends DialogData = DialogData> {
  constructor(
    public dialogRef: DialogRef<DialogComponent<T>>,
    iconRegistryService: IconRegistryService,
    @Inject(DIALOG_DATA) public data: T,
  ) {
    iconRegistryService.registerIcons([IconX]);
  }

  onClose() {
    if (!this.dialogRef.disableClose) {
      this.dialogRef.close();
    }
  }
}
